import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ColorBadge } from "@netapp/bxp-design-system-react";
import { globalSearch as i18nNamespace } from "../../../i18n/namespace";
import { consoleObjectStatusDetail, consoleObjectStatusLabel, consoleObjectTypeLabel, getStatusTone } from "../consoleObjects";
import { inputMethodFromInteraction } from "../globalSearchFullStory";
import { navigateToConsoleObject } from "../consoleObjectNavigation";
import styles from "../GlobalSearch.module.scss";

export const highlightMatch = (value, searchTerm) => {
    if (typeof value !== "string" || !value || !searchTerm) {
        return value;
    }
    const index = value.toLowerCase().indexOf(searchTerm.toLowerCase());
    if (index < 0) {
        return value;
    }

    return <span>
        {value.substring(0, index)}
        <strong>{value.substring(index, index + searchTerm.length)}</strong>
        {value.substring(index + searchTerm.length)}
    </span>;
};

const STATUS_BADGE_COLOR = {
    success: "green",
    error: "red",
    warning: "orange",
    information: "blue",
    neutral: "grey"
};

const ConsoleObjectResult = ({ id, name, objectType, path, status, statusTone, statusDetail, fleetId, clusterId, workingEnvironmentId, clusterPersonality, rank = null }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation(i18nNamespace);
    const searchTerm = useSelector(state => state.globalSearch.searchTerm);
    const agentId = useSelector(state => state.tenancy?.selectedAgentId);
    const typeLabel = consoleObjectTypeLabel(objectType, t);
    const statusLabel = consoleObjectStatusLabel(status, t);
    const statusTooltip = consoleObjectStatusDetail(statusDetail, t);
    const tone = statusTone || getStatusTone(status);
    const result = { id, name, objectType, path, status, statusTone, statusDetail, fleetId, clusterId, workingEnvironmentId, clusterPersonality };

    return <button type="button" className={styles['object-row']} onClick={event => {
        dispatch({
            type: "GLOBAL-SEARCH/SELECT-SEARCH/console-object",
            payload: result,
            track: `${objectType}/${name}`,
            rank,
            inputMethod: inputMethodFromInteraction(event)
        });
        dispatch({
            type: "GLOBAL-SEARCH/CLOSE"
        });
        navigateToConsoleObject({ history, dispatch, agentId, result });
    }}>
        <span className={styles['object-name']} title={name}>{highlightMatch(name, searchTerm)}</span>
        <span className={styles['object-path']} title={(path || []).join(" → ")}>{(path || []).join(" → ")}</span>
        {(objectType || status) && <span className={styles['object-type']}>
            {objectType && <span>{typeLabel}</span>}
            {objectType && status && <span className={styles['object-divider']}>|</span>}
            {status && <ColorBadge color={STATUS_BADGE_COLOR[tone] || "grey"} ariaLabel={statusLabel} {...(statusTooltip ? { tooltip: statusTooltip } : {})} />}
            {status && <span>{statusLabel}</span>}
        </span>}
    </button>
};

export default React.memo(ConsoleObjectResult);
